import { useEffect } from 'react';
import { useCustomerio } from '../contexts/CustomerIOContext.jsx';
import { useFlags } from 'launchdarkly-react-client-sdk';

export default function CustomerIOPlaceholder({ children, id, className }) {
  const { cioTrack, cioPage } = useCustomerio();
  const { emergencyFrontendBannerWithMessage } = useFlags();

  useEffect(() => {
    cioPage(window.location.pathname, {
      element_id: id,
    });
    let attributes = {
      page: window.location.pathname,
      element_id: id,
    };
    cioTrack('Page Viewed', attributes);
  }, []);

  if (emergencyFrontendBannerWithMessage) {
    // if we're in an emergency state, don't show any CIO elements
    return null;
  }
  return (
    <div id={id} className={className}>
      {children}
    </div>
  );
}
